import { render, staticRenderFns } from "./RecursosHumanos.vue?vue&type=template&id=32943044&scoped=true&"
import script from "./RecursosHumanos.vue?vue&type=script&lang=js&"
export * from "./RecursosHumanos.vue?vue&type=script&lang=js&"
import style0 from "./RecursosHumanos.vue?vue&type=style&index=0&id=32943044&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32943044",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VMain})
